import { FooterLinkTypes } from '../../custom-types/footer';
import { toLink, toText } from '../../fields';
import { Link } from '../../fields/link';

export const footerLink = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): FooterLink | undefined => {
  const link = toLink(data.primary?.link);
  const label = toText(data.primary?.label);

  if (!link || !label) {
    return undefined;
  }

  return {
    type: FooterLinkTypes.FOOTER_LINK,
    label,
    link,
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rgpdLink = (data: Record<string, any>): FooterLink | undefined => {
  const label = toText(data.primary?.label);

  if (!label) {
    return undefined;
  }

  return {
    type: FooterLinkTypes.RGPD_LINK,
    label,
  };
};

export type FooterLink = {
  type: FooterLinkTypes;
  label: string;
  link?: Link;
};
